import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoEdit from "../../components/PageInfoEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";
import GalleryEdit from "../../components/GalleryEdit";

export default function Kirekligehandlinger() {
    const uploadFolderId = '1WdlsHlN5wqkoyxvpMqEhwfJiqyhVw1W-'
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/KirkeligeHandlinger">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoEdit sectionKey="Sec1" />
                <PageInfoEdit sectionKey="Sec2" />
                <GalleryEdit sectionKey="Gallery" />
                <PageInfoEdit sectionKey="Sec3" />
                <PageInfoEdit sectionKey="Sec4" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}